module.exports = __webpack_public_path__ + "img/nbwxyj.da3019e5.png";